export default "__VITE_ASSET__8IBCsFTT__"